<template>
  <div id="app">
    <Loading v-if="preloader"></Loading>
    <Header v-if="!toogleHeaderLandingPage && !preloader" :toogleMicroApp="toogleMicroApp" />
    <HeaderLandingPage v-if="toogleHeaderLandingPage && !preloader" :toogleMicroApp="toogleMicroApp" />
    <main v-if="!preloader">
      <router-view />
    </main>
    <Footer v-if="(!preloader && toogleMicroApp)" />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Loading from '@/components/Loading.vue'
import { APIService } from './APIService'
import {
  handleAccessToken,
  handleBearerSportheca,
} from '@/shared/helpers/helpers'
import {authApp, authUserByCode, getLoggedUser } from "./service/clube/serviceAuthAPI.js";



const apiService = new APIService()

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Loading,
  },
  data() {
    return {
      fonteImport: window.FONTE_IMPORT,
      preloader: true,
    }
  },
  created() {
    //const config = JSON.parse(localStorage.getItem(location.hostname));
  },
  beforeMount() {
    let bearerTokenOneFan = ''
    apiService.obterConfig(location.hostname).then((response) => {
      localStorage.setItem(location.hostname, JSON.stringify(response))
      this.loadConfigWritelabel()

      bearerTokenOneFan = this.$route.query.bearerTokenOneFan
        ? this.$route.query.bearerTokenOneFan
        : window.navigator.bearerTokenOneFan
      if (bearerTokenOneFan) {
        handleBearerSportheca(bearerTokenOneFan).then(() => {
          if (this.$route.name === 'ClubeDesconto') {
            this.$router.push('/servico/clube-desconto')
            window.location.reload()
          } else {
            this.$router.push('/')
          }
          this.loading = false
        })
      }
    })

    let toogleMicroApp = this.$route.query.toogleMicroApp
    this.$store.dispatch('toogleMicroApp', +toogleMicroApp)

    localStorage.removeItem('accessToken');
    localStorage.removeItem('token');
    localStorage.removeItem('token_api_sso');

    let accessToken = this.$route.query.accessToken

    const iu = this.$route.query.u

    accessToken = accessToken ? accessToken : iu


    const urlSlug = this.$route.params.urlSlug;

    localStorage.removeItem('urlSlug')
    localStorage.setItem('urlSlug', urlSlug)

    if (accessToken && bearerTokenOneFan) {
      handleAccessToken(accessToken).then(() => (this.loading = false));      
    } else {
      this.preloader = true;
      const token = localStorage.getItem("token");
      if (this.$route.query.accessToken && !token) {
        authApp().then(auth => {
          if (auth.code === "200") {
            localStorage.removeItem("token_api_sso");
            localStorage.setItem("token_api_sso", auth.data.token);
            const loginUserCode = {
              grantType: "access_token",
              UserCode: this.$route.query.accessToken              
            }

            authUserByCode(loginUserCode).then(authUser => {
              if (authUser.code === "200") {
                localStorage.removeItem("token_api_sso");
                localStorage.setItem("token_api_sso", authUser.data.token);
                getLoggedUser().then(user => {
                  if (user.code === "200") {
                    apiService
                      .registerSso({
                        firstName: user.data.firstName,
                        lastName: user.data.lastName,
                        email: user.data.email,
                        cellPhone: user.data.phone,
                        login: user.data.login,
                        id: user.data.id,
                        userCode: user.data.userCode,
                      }) 
                      .then(response => {
                          response,
                          window.location.reload();
                          this.$router.go(0);
                          this.preloader = false;                          
                      })                     
                      .catch(error => {
                        this.erro = error.response.data.title;
                        this.preloader = false;
                        window.scrollTo(0, 0);
                      });
                  }
                })
              }
            }).catch(error => {
              this.erro = `500 - ${error.data}`;
            })
          }
        });
      }
    }

    const token = sessionStorage.getItem('token')
    if (token) {
      apiService
        .obterDadosUsuario(token)
        .then((response) => this.$store.dispatch('loginApp', response))
    } else {
      this.$store.dispatch('loginApp', null)
    }
  },
  methods: {
    loadConfigWritelabel() {
      this.preloader = true
      this.loadConfig()
      this.configLayout()
      this.facebookPixel()
      this.gooleAnalytics()
      this.preloader = false
    },
    loadConfig() {
      const config = JSON.parse(
        window.localStorage.getItem(window.location.hostname),
      )
      if (config) {
        window.MODULOS = config.MODULOS
        window.CONFIG_API = config.CONFIG_API
        window.NOME = config.NOME
        window.SITE = config.SITE
        window.LOGO_TOPO = config.LOGO_TOPO
        window.LOGO_RODAPE = config.LOGO_RODAPE
        window.IMAGEM_LANDING_PAGE_01 = config.IMAGEM_LANDING_PAGE_01
        window.IMAGEM_LANDING_PAGE_02 = config.IMAGEM_LANDING_PAGE_02
        window.TEXTO_BANNER_LANDING_PAGE = config.TEXTO_BANNER_LANDING_PAGE
        window.FACEBOOK = config.FACEBOOK
        window.WHATSAPP = config.WHATSAPP
        window.YOUTUBE = config.YOUTUBE
        window.INSTAGRAM = config.INSTAGRAM
        window.TWITTER = config.TWITTER
        window.LINKEDIN = config.LINKEDIN
        window.BANNER_PRINCIPAL = config.BANNER_PRINCIPAL
        window.BANNER_CLUBE = config.BANNER_CLUBE
        window.COR_PRINCIPAL = config.COR_PRINCIPAL
        window.COR_SECUNDARIA = config.COR_SECUNDARIA
        window.COR_TEXTO = config.COR_TEXTO
        window.CONTROLE_ESTOQUE = config.CONTROLE_ESTOQUE
        window.APP_ORIGIN = config.APP_ORIGIN
        window.URL_SLUG = config.URL_SLUG
        window.BASE_PATH = config.BASE_PATH
        window.API_BASE_URL = config.API_BASE_URL
        window.FONTE_NOME = config.FONTE_NOME
        window.FONTE_IMPORT = config.FONTE_IMPORT
        window.PIXEL_CODE = config.PIXEL_CODE
        window.GOOGLE_ANALYTICS = config.GOOGLE_ANALYTICS
        window.FOOTER_MENU = config.FOOTER_MENU
      }
    },

    configLayout() {
      let link = document.querySelector("link[rel~='icon']")
      document.title = window.NOME
     
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      link.href = window.LOGO_RODAPE

      let bodyStyles = document.body.style
      bodyStyles.setProperty(
        '--fonte-nome',
        window.FONTE_NOME.replace(/"/g, ''),
      )
      bodyStyles.setProperty('--cor-secundaria', window.COR_SECUNDARIA)
      bodyStyles.setProperty('--cor-secundaria2', window.COR_SECUNDARIA2)
      bodyStyles.setProperty('--cor-secundaria3', window.COR_SECUNDARIA3)
      bodyStyles.setProperty('--cor-principal', window.COR_PRINCIPAL)
      bodyStyles.setProperty('--cor-texto', window.COR_TEXTO)

      let linkFont = document.createElement('link')
      linkFont.setAttribute('rel', 'stylesheet')
      linkFont.setAttribute('type', 'text/css')
      linkFont.setAttribute(
        'href',
        window.FONT_IMPORT || './assets/scss/_flama.scss',
      )
      document.head.appendChild(linkFont)
    },

    facebookPixel() {
      if (window.PIXEL_CODE) {
        !(function (f, b, e, v, n, t, s) {
          if (f.fbq) return
          n = f.fbq = function () {
            n.callMethod
              ? n.callMethod.apply(n, arguments)
              : n.queue.push(arguments)
          }
          if (!f._fbq) f._fbq = n
          n.push = n
          n.loaded = !0
          n.version = '2.0'
          n.queue = []
          t = b.createElement(e)
          t.async = !0
          t.src = v
          s = b.getElementsByTagName(e)[0]
          s.parentNode.insertBefore(t, s)
        })(
          window,
          document,
          'script',
          'https://connect.facebook.net/en_US/fbevents.js',
        )
        window.fbq('init', window.PIXEL_CODE)
      }
    },
    gtag() {
      window.dataLayer.push(arguments)
    },
    gooleAnalytics() {
      if (window.GOOGLE_ANALYTICS) {
        this.gtag('js', new Date())
        this.gtag('config', window.GOOGLE_ANALYTICS)
      }
    },
    setPedidoToLocalStorage(pedido) {
      this.$store.state.pedido.itens = []
      this.$store.state.pedido.valorTotal = 0
      this.$store.state.pedido.valorFrete = 0
      this.$store.state.pedido.valorCompra = 0
      this.$store.state.pedido.valorDesconto = 0
      this.$store.state.pedido.id = null

      if (pedido.status === 'AGUARDANDO_CHECKOUT') {
        this.$store.state.pedido.itens = pedido.itens
        this.$store.state.pedido.valorTotal = pedido.valorTotal
        this.$store.state.pedido.valorFrete = pedido.valorFrete
        this.$store.state.pedido.valorCompra = pedido.valorCompra
        this.$store.state.pedido.valorDesconto = pedido.valorDesconto
        this.$store.state.pedido.id = pedido.id
      }

      setTimeout(() => {
        localStorage.setItem(
          'carrinho',
          JSON.stringify(this.$store.state.pedido),
        )
      }, 500)
    },
  },
  computed: {
    toogleMicroApp() {
      return this.$store.state.toogleMicroApp
    },
    toogleFooter() {
      return this.$store.state.toogleFooter
    },
    toogleHeaderLandingPage() {
      return this.$route.meta.headerLandingPage
    },
  },
  watch: {
    '$store.state.pedido': function () {
      const carrinho = localStorage.getItem('carrinho')

      if (!carrinho || carrinho === '""' || carrinho === "''") {
        localStorage.removeItem('carrinho')
      }
    },
  },
}
</script>

<style lang="scss">
@import './assets/scss/bootstrap.min.css';
@import '~sweetalert2/src/variables';
@import '~sweetalert2/src/sweetalert2';

body {
  font-size: 16px;
  margin: 0;
  font-family: var(--fonte-nome);
  font-weight: 400;
}

hr {
  border: 0;
  display: flex;
  flex: 1;
  background: var(--cor-secundaria);
  height: 2px;
  position: relative;
}

.titulo-topo {
  color: var(--cor-principal);
  font-size: 1.3rem;
  margin: 0 8px;
}

h2 {
  font-weight: 800;
  font-size: 3.3em;
}

button {
  background: var(--cor-principal);
  color: var(--cor-texto);
}

.modal-body {
  .item_produto {
    box-shadow: none !important;
  }
}

.btn_adicionar {
  color: var(--cor-texto) !important;
  background-color: var(--cor-principal);
  border: 1px solid var(--cor-principal);
  text-transform: uppercase;
}

.btn_color_system {
  color: var(--cor-texto) !important;
  background-color: var(--cor-principal) !important;
}

.modal-full {
  max-width: none;
  width: 100vw;
  margin: 0;
}

.modal-body-full {
  overflow: auto;
  min-height: 78vh;
  max-height: 78vh;
  width: 100%;
  border: 0;
}

.assinar-plano-checkout {
  position: fixed;
  bottom: 0;
  margin: 0 !important;
  left: 0;
  min-width: 100% !important;
  flex-direction: row !important;
  justify-content: space-around !important;
  height: 100px !important;
}

.valor-plano {
  color: var(--cor-principal);
  font-size: 16px;
  align-content: center;
  align-items: center;
  font-weight: bold;
}

.btn-aderir-plano {
  background-color: var(--cor-principal);
  color: white;
  border-radius: 16px;
  font-weight: 600;
  font-size: 16px;
  margin-top: 30px;
  max-width: 150px;
  max-height: 40px;
  align-content: center !important;
  align-items: center !important;
}

.lista_produtos {
  .item_produto {
    border-radius: 8px;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    border: 1px solid #efefef;
    transition: box-shadow 0.4s;
  }

  .item_produto {
    &:hover {
      -webkit-box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.45);
      -moz-box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.45);
      box-shadow: 0px 4px 11px 0px rgba(0, 0, 0, 0.45);
    }

    .titulo_categoria {
      font-weight: 400;
      font-size: 1.5em;

      &.ellipsis {
        >div {
          background-color: #fff;
          position: relative;
          width: 100%;
          padding-top: 100%;
          background-position: center;
          background-size: cover;
        }

        >span {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          min-height: 80px;
        }
      }
    }

    .esgotado:after {
      content: 'ESGOTADO';
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: 5vw;
      transform-origin: 50% 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
      font-weight: bold;
      color: var(--cor-principal);
      text-shadow: 0 3px 6px black;
    }

    .plano {
      margin-top: 1rem;
      border-bottom: 1px solid #c1c6c8;
      padding-bottom: 0.8rem;

      strong {
        font-weight: 800;
        font-size: 1.4em;
        display: block;
      }

      p {
        margin: 0;

        &:last-child {
          font-weight: 600;
          color: #2d2926;
          display: block;
          font-size: 1.2em;
        }
      }
    }

    .tamanho-valor {
      min-height: 80px;

      .valor {
        margin-top: 0.7rem;

        .preco {
          color: #5b6770;
          display: block;
          font-size: 1.3em;
        }

        .a-vista {
          color: #5b6770;
          display: block;
          font-size: 0.8em;
        }

        .parcelas {
          color: #495057;
          display: block;
          font-size: 0.8em;
        }

        .a-prazo {
          color: #495057;
          display: block;
          font-size: 0.8em;
        }
      }
    }

    .btn_selecionar {
      color: var(--cor-texto) !important;
      background-color: var(--cor-principal);
      border: 1px solid var(--cor-principal);
      display: block;
      width: 100%;
      padding: 0.6rem;
      text-align: center;
      text-transform: uppercase;
      margin-top: 1rem;
      cursor: pointer;
      border-radius: 0.25rem;
    }

    .quantidade {
      border-bottom: 1px solid #c1c6c8;
      border-top: 1px solid #c1c6c8;
      padding: 1rem 0;
      margin: 1rem 0;

      button {
        width: 40px;
        height: 40px;
        max-width: 40px;
        max-height: 40px;
        background-color: #fff;
        border: 1px solid #2d2926;
        border-radius: 50px;
        font-size: 1.2em;
        font-weight: 800;
      }

      input {
        text-align: center;
        font-size: 1.3em;
        min-width: 60px;
        border: 0;
        margin-left: 11px;
      }
    }

    .quantidade-modificador {
      padding: 0.2rem 0;
      margin-left: 0.4rem;

      button {
        width: 35px;
        height: 35px;
        max-width: 40px;
        max-height: 40px;
        background-color: #fff;
        border: 1px solid #2d2926;
        border-radius: 100px;
        font-size: 1.0em;
        font-weight: 800;

      }

      input {
        text-align: center;
        font-size: 0.8em;
        min-width: 40px;
        min-width: 60px;
        border: 0;
        margin: -40px;

      }
    }

    .quantidade-modificador-radio {
      padding: 0.2rem 0;
      margin: 0.4rem 0;

      button {
        width: 35px;
        height: 35px;
        max-width: 40px;
        max-height: 40px;
        background-color: #fff;
        border: 1px solid #2d2926;
        border-radius: 100px;
        font-size: 1.0em;
        font-weight: 800;

      }

      input {
        text-align: center;
        font-size: 1.3em;
        min-width: 40px;
        min-width: 60px;
        border: 0;
        margin: 1px;
      }
    }

    &.item_familia .titulo_categoria {
      color: #d7282f;
    }

    &.item_semestral .plano .periodo {
      color: #d7282f;
    }

    &.item_anual .plano .periodo {
      color: #62b5e5;
    }

    &.item_promocao .titulo_categoria {
      color: #ff9e1b;
    }

    &.item_promocao.item_semestral .plano .periodo {
      color: #ff9e1b;
    }

    &.item_promocao.item_anual .plano .periodo {
      color: #ff9e1b;
    }

    &.item_promocao .btn_selecionar {
      color: #fff;
      border: 1px solid #ff9e1b;
      background-color: #ff9e1b;
    }
  }
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-auto {
  overflow: auto !important;
}

.VueCarousel-pagination * {
  padding: 5px;
  margin-top: -4px !important;
  background: var(--cor-secundaria);
  width: 100%;
}

.VueCarousel-slide {
  width: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.text-bold {
  font-weight: bold;
}

.accordion .card-header {
  position: relative;
  padding-right: 56px;

  &:after {
    content: '';
    position: absolute;
    right: 28px;
    top: 16px;
    width: 4px;
    height: 16px;
    background: #ccc;
    transition: 0.3s all ease-in-out;
  }

  &.open:after,
  &:before {
    content: '';
    position: absolute;
    right: 22px;
    top: 22px;
    width: 16px;
    height: 4px;
    background: #ccc;
  }
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.cursor-pointer {
  cursor: pointer;
}

.spinner-border {
  display: inline-block;
  width: 23px;
  height: 23px;
  vertical-align: text-bottom;
  border: 2px solid currentColor;
  border-right-color: transparent;
  // stylelint-disable-next-line property-blacklist
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.aguarde-container {
  left: 50%;
  margin-left: 40px;
  margin-top: 230px;
  margin-right: 40px;
}

.aguarde-container-mensagem {
  left: 50%;
  margin-left: 40px;
  margin-top: 230px;
  margin-right: 40px;
}

.aguarde {
  position: absolute;
  left: 50%;
  top: 30%;
  margin-left: -80px;
  margin-top: -50px;
}

.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: '';
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid var(--cor-secundaria);
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }
}

@media (max-width: 600px) {
  body {
    font-size: 12px;
  }
}

// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) {
  .border-lg-none {
    border: none !important;
  }

  .esgotado:after {
    font-size: 6vw !important;
  }
}

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) and (max-width: 767.98px) {
  .border-lg-none {
    border: none !important;
  }

  .esgotado:after {
    font-size: 6vw !important;
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) and (max-width: 991.98px) {
  .border-lg-none {
    border: none !important;
  }

  .esgotado:after {
    font-size: 6vw !important;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) and (max-width: 1199.98px) {
  .esgotado:after {
    font-size: 5vw !important;
  }
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) and (max-width: 1919.98px) {
  .container {
    max-width: 1560px;
  }

  .esgotado:after {
    font-size: 2.5vw !important;
  }
}

@media (min-width: 1920px) {
  .container {
    max-width: 1560px;
  }

  .esgotado:after {
    font-size: 3vw !important;
  }
}

@media (min-width: 991px) {
  .centralizar .VueCarousel-inner {
    justify-content: center !important;
  }

  .VueCarousel-slide {
    img {
      max-height: 398px;
      max-width: 1200px;
      border-radius: 5px;
    }
  }

}

.swal2-title {
  font-size: 1.8rem;
}
</style>
